import React, { useState } from "react";
import { useTranslate } from "@refinedev/core";
import { LightningIcon } from "@phosphor-icons/react";
import styled from "styled-components";
import { useQuota } from "hooks/useQuota";
import { QuotaFeatures } from "@/constants";
import PricingModal from "pages/subscription/components/PricingModal/";
import { useAnalytics } from "hooks/useAnalytics";
import { AnalyticsEvents } from "types/analytics";
import { radius } from "@libertify/ui";

const FooterWrapper = styled.div`
  flex-shrink: 0;
  padding: 0 24px 32px;
  text-align: center;
`;

const MinutesLeft = styled.p`
  font-size: 12px;
  color: #9ca3af;
  margin: 0 0 8px;
`;

const UpgradeBtn = styled.button`
  background: transparent;
  color: #6d28d9;
  border: 1.5px solid #6d28d9;
  border-radius: ${radius.pill}px;
  padding: 6px 18px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: background 0.15s;

  &:hover {
    background: #f5f3ff;
  }
`;

function formatRemainingTime(rawValue: number): string {
  // The quota value is in seconds; convert to minutes for display
  const minutes = Math.round(rawValue / 60);
  if (minutes < 1) return "<1";
  return `${minutes}`;
}

export const CreatorFooter: React.FC = () => {
  const t = useTranslate();
  const { remaining, getQuota, isLoading } = useQuota();
  const [isPricingModalOpen, setIsPricingModalOpen] = useState(false);
  const { trackEvent } = useAnalytics();

  const quota = getQuota(QuotaFeatures.MediaProject);
  const hasLimit =
    !isLoading &&
    quota?.quota_limit !== null &&
    quota?.quota_limit !== undefined;

  const remainingValue = remaining(QuotaFeatures.MediaProject);
  const remainingLabel = hasLimit ? formatRemainingTime(remainingValue) : null;

  return (
    <FooterWrapper>
      {remainingLabel && (
        <MinutesLeft>{remainingLabel} creation minutes left</MinutesLeft>
      )}

      <>
        <UpgradeBtn
          onClick={() => {
            trackEvent(AnalyticsEvents.UpgradeButtonClick, {
              location: "experience_preview",
            });
            setIsPricingModalOpen(true);
          }}
        >
          <LightningIcon size={12} weight="fill" />
          {t("buttons.upgradeToPro", "Upgrade to Pro")}
        </UpgradeBtn>
        <PricingModal
          open={isPricingModalOpen}
          onClose={() => setIsPricingModalOpen(false)}
        />
      </>
    </FooterWrapper>
  );
};
